/* ELLESANTI · tema V3 · pre-carrello (5/10/2026, CTRL+G). Nessuna libreria.
   Arricchisce i due pannelli «Aggiunto al carrello» (scheda: [data-e-addp], anteprima rapida: [data-e-lv-add]) quando si aprono:
   1 · riepilogo del carrello («Nel carrello: 3 gioielli · 130 €»);
   2 · spedizione gratuita con la soglia del paese: Italia 150 €, resto d'Europa 250 €; fuori Europa o in altra valuta la barra non c'è;
       raggiunta la soglia: «La spedizione è gratuita.»;
   3 · gioielli proposti: fino a tre (sections/v3-pc-rec). Ordine: complementari scelti a mano in Search & Discovery, stessa famiglia
       e tipo diverso, stesso momento e tipo diverso, simili di Shopify; senza quelli già nel carrello. Se manca qualcosa alla soglia,
       dopo quelli scelti a mano e la famiglia vengono prima quelli che la raggiungono. Titolo: «Aggiungi un altro gioiello per la spedizione gratuita» sotto la soglia,
       «Scopri anche» quando è raggiunta (o fuori Europa). «+» aggiunge subito il gioiello con un solo modello; con più colori
       o taglie apre l'anteprima rapida;
   4 · bottoni: «Procedi all'acquisto» (al pagamento) in primo piano, poi «Vedi il carrello» e «Continua a guardare»;
   5 · le tre garanzie con icona al posto della riga piccola (modello <template data-e-pc-tpl> in snippets/v3-livelli);
   6 · «Quantità» si vede solo se è più di 1.
   Il carrello arriva dall'evento «ellesanti:cart» che scheda e anteprima mandano dopo ogni aggiunta. */
(function () {
  'use strict';
  var H = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* 09/10: il numero del carrello conta i gioielli, non le confezioni regalo */
  function nGio(c) { var n = (c && c.item_count) || 0; ((c && c.items) || []).forEach(function (x) { if (x.handle === 'confezione-regalo') n -= x.quantity; }); return n; }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EN = /^en/i.test(H.lang || '');
  var C = {};
  try { C = JSON.parse(($('[data-e-pc-json]') || {}).textContent || '{}'); } catch (e) { C = {}; }
  if (C.b2b) return;
  /* paesi della zona «Europa» di Shopify (Impostazioni › Spedizioni, 25 €, gratuita da 250 €): se cambia la zona, aggiornare qui */
  var EU = ['AD','AL','AT','AX','BA','BE','BG','BY','CY','CZ','DE','DK','EE','ES','FI','FO','FR','GB','GG','GI','GR','HR','HU','IE','IM','IS','JE','LI','LT','LU','LV','MC','MD','ME','MK','MT','NL','PL','PT','RO','RS','RU','SE','SI','SJ','SK','SM','UA','VA','XK'];
  var T = EN ? {
    nel: 'In your bag', gioiello: 'piece', gioielli: 'pieces',
    manca_it: 'Add [m] more for free shipping in Italy.', manca_eu: 'Add [m] more for free shipping in Europe.',
    ok: 'Shipping is free.', scopri: 'Discover more', sped: 'Add another piece for free shipping',
    procedi: 'Proceed to checkout', carrello: 'View your bag', aggiungi: 'Add ', aggiunto: 'Added', errore: 'It could not be added. Try again.'
  } : {
    nel: 'Nel carrello', gioiello: 'gioiello', gioielli: 'gioielli',
    manca_it: 'Ti mancano [m] per la spedizione gratuita in Italia.', manca_eu: 'Ti mancano [m] per la spedizione gratuita in Europa.',
    ok: 'La spedizione è gratuita.', scopri: 'Scopri anche', sped: 'Aggiungi un altro gioiello per la spedizione gratuita',
    procedi: 'Procedi all’acquisto', carrello: 'Vedi il carrello', aggiungi: 'Aggiungi ', aggiunto: 'Aggiunto', errore: 'Non è stato possibile aggiungerlo. Riprova.'
  };
  var paese = String(C.paese || 'IT').toUpperCase();
  var SOGLIA = paese === 'IT' ? (C.soglia || 15000) : (EU.indexOf(paese) > -1 ? (C.soglia_eu || 25000) : 0);
  var cart = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var n = c / 100, cur = cart && cart.currency;
    if (!cur || cur === 'EUR') return (n % 1 === 0 ? String(n) : n.toFixed(2).replace('.', ',')) + ' €';
    try { return new Intl.NumberFormat(H.lang || 'it', { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2) + ' ' + cur; }
  }
  function conta(n) { $$('.e-hd__count, .e-bbar__count').forEach(function (c) { c.textContent = n; c.classList.toggle('is-visible', n > 0); }); }
  function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function fisico() {
    var t = 0, f = false;
    ((cart && cart.items) || []).forEach(function (x) { if (x.requires_shipping) { f = true; t += x.final_line_price; } });
    return { tot: t, fis: f };
  }
  function manca() { var s = fisico(); return (SOGLIA && s.fis && (!cart.currency || cart.currency === 'EUR')) ? SOGLIA - s.tot : null; }

  /* ---------------------------------------------------------------- pannello */
  function prepara(P) {
    if (P._pc) return;
    P._pc = true;
    P.classList.add('e-pc');
    var ship = $('.e-addp__ship', P);
    var sum = document.createElement('p');
    sum.className = 'e-pc__sum';
    if (ship) ship.parentNode.insertBefore(sum, ship);
    var rec = document.createElement('section');
    rec.className = 'e-pc__rec';
    rec.hidden = true;
    rec.innerHTML = '<p class="e-pc__k"></p><div class="e-pc__g"></div>';
    if (ship) ship.parentNode.insertBefore(rec, ship.nextSibling);
    /* bottoni */
    var a = $('.e-addp__a', P);
    if (a) {
      var vai = $('a.e-btn', a);
      if (vai) { vai.textContent = T.procedi; vai.setAttribute('href', ROOT + 'checkout'); }
      var cont = $('button.e-btn', a);
      var row = document.createElement('div');
      row.className = 'e-pc__sec';
      row.innerHTML = '<a class="e-link e-link--sm" href="' + ROOT + 'cart">' + esc(T.carrello) + '</a>';
      if (cont) { cont.classList.remove('e-btn', 'e-btn--line'); cont.classList.add('e-link', 'e-link--sm'); row.appendChild(cont); }
      a.appendChild(row);
    }
    /* garanzie */
    var n = $('.e-addp__n', P), tpl = $('[data-e-pc-tpl]');
    if (n && tpl && tpl.content) { n.parentNode.insertBefore(tpl.content.cloneNode(true), n); n.hidden = true; }
    /* «+» */
    rec.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-e-pc-add]');
      if (!b) return;
      var it = b.closest('[data-e-pc-it]'), vid = it && it.getAttribute('data-vid');
      if (!vid) {
        /* più colori o taglie: si chiude il pannello e si apre l'anteprima rapida (v3-livelli.js ascolta [data-e-qv]) */
        b.setAttribute('data-e-qv', it.getAttribute('data-handle'));
        var x = $('[data-e-addx], [data-e-lv-chiudi]', P);
        if (x) x.click();
        return;
      }
      if (b.classList.contains('is-busy') || b.classList.contains('is-ok')) return;
      b.classList.add('is-busy');
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +vid, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(getCart)
        .then(function (c) {
          cart = c;
          conta(nGio(c));
          c._da = 'precarrello';
          document.dispatchEvent(new CustomEvent('ellesanti:cart', { detail: c }));
          b.classList.add('is-ok');
          b.setAttribute('aria-label', T.aggiunto);
          var l = document.createElement('span'); l.className = 'e-pc__ok'; l.textContent = T.aggiunto; it.appendChild(l);
          stato(P);
        })
        .catch(function (er) { var l = document.createElement('span'); l.className = 'e-pc__ok e-pc__ok--err'; l.textContent = (er && er.description) || T.errore; it.appendChild(l); })
        .then(function () { b.classList.remove('is-busy'); });
    });
  }

  function stato(P) {
    if (!cart) return;
    /* riepilogo */
    var sum = $('.e-pc__sum', P);
    if (sum) {
      var q = cart.item_count;
      /* 09/10: la confezione regalo non è un gioiello */
      (cart.items || []).forEach(function (x) { if (x.handle === 'confezione-regalo') q -= x.quantity; });
      sum.innerHTML = esc(T.nel) + ': <b>' + q + ' ' + esc(q === 1 ? T.gioiello : T.gioielli) + ' · ' + esc(money(cart.total_price)) + '</b>';
    }
    /* spedizione */
    var ship = $('.e-addp__ship', P), m = manca();
    if (ship) {
      ship.hidden = m === null;
      var p = $('p', ship), bar = $('.e-addp__bar i', ship);
      if (m !== null) {
        if (p) p.innerHTML = m > 0 ? esc((paese === 'IT' ? T.manca_it : T.manca_eu)).replace('[m]', '<b>' + esc(money(m)) + '</b>') : esc(T.ok);
        if (bar) {
          var w = Math.min(100, 100 * fisico().tot / SOGLIA);
          requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.width = w.toFixed(1) + '%'; }); });
        }
      }
    }
    /* «Quantità: 1» */
    $$('[data-e-addq]', P).forEach(function (s) { var r = s.closest('.e-ferro'); if (r) r.hidden = s.textContent.trim() === '1'; });
    $$('[data-e-addtg]', P).forEach(function (s) { var r = s.closest('.e-ferro'); if (r) r.hidden = !s.textContent.trim(); });
    ordina(P);
  }

  /* ---------------------------------------------------------------- gioielli proposti */
  var cache = {};
  function consigli(pid, handle) {
    if (cache[pid]) return cache[pid];
    var u = function (i) {
      return i === 'regola' ? ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=v3-pc-rec'
        : ROOT + 'recommendations/products?product_id=' + pid + '&limit=8&intent=' + i + '&section_id=v3-pc-rec';
    };
    var get = function (i) {
      if (i === 'regola' && !handle) return Promise.resolve([]);
      return fetch(u(i)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
        var d = new DOMParser().parseFromString(h || '', 'text/html'), L = $$('[data-e-pc-it]', d);
        /* scelti a mano in Search & Discovery: davanti come la famiglia */
        if (i === 'complementary') L.forEach(function (n) { n.setAttribute('data-pri', ''); });
        return L;
      }).catch(function () { return []; });
    };
    cache[pid] = Promise.all([get('complementary'), get('regola'), get('related')]).then(function (r) {
      var visti = {}, out = [];
      r[0].concat(r[1], r[2]).forEach(function (n) { var id = n.getAttribute('data-id'); if (!visti[id]) { visti[id] = 1; out.push(n); } });
      return out;
    });
    return cache[pid];
  }
  function ordina(P) {
    var rec = $('.e-pc__rec', P);
    if (!rec || !P._items) return;
    var nel = {};
    (cart.items || []).forEach(function (x) { nel[x.product_id] = 1; });
    var L = P._items.filter(function (n) { return !nel[n.getAttribute('data-id')] || n._aggiunto; });
    var m = manca();
    if (m !== null && m > 0) {
      /* scelti a mano e stessa famiglia restano davanti; poi, fra gli altri, prima quelli che raggiungono la soglia */
      var pri = L.filter(function (n) { return n.hasAttribute('data-pri'); });
      var alt = L.filter(function (n) { return !n.hasAttribute('data-pri'); });
      var su = alt.filter(function (n) { return +n.getAttribute('data-price') >= m; });
      var giu = alt.filter(function (n) { return su.indexOf(n) < 0; });
      L = pri.concat(su, giu);
    }
    L = L.slice(0, 3);
    var g = $('.e-pc__g', rec), k = $('.e-pc__k', rec);
    if (!rec._fatto) {
      g.innerHTML = '';
      L.forEach(function (n) {
        var c = document.importNode(n, true);
        var nm = $('.e-pc__n', c), b = $('[data-e-pc-add]', c);
        if (b && nm) b.setAttribute('aria-label', T.aggiungi + nm.textContent.trim());
        g.appendChild(c);
      });
      rec._fatto = true;
    }
    k.textContent = (m !== null && m > 0) ? T.sped : T.scopri;
    rec.hidden = !g.children.length;
  }
  function riempi(P) {
    var rec = $('.e-pc__rec', P);
    if (!rec || !cart || !cart.items || !cart.items.length) return;
    var pid = cart.items[0].product_id, handle = cart.items[0].handle;
    rec._fatto = false;
    rec.hidden = true;
    P._items = null;
    P._pid = pid;
    consigli(pid, handle).then(function (items) {
      if (P._pid !== pid) return;
      P._items = items;
      ordina(P);
    });
  }

  /* ---------------------------------------------------------------- avvio */
  function apre(P) {
    prepara(P);
    var go = function () { stato(P); riempi(P); };
    if (cart) go(); else getCart().then(function (c) { cart = c; go(); });
  }
  document.addEventListener('ellesanti:cart', function (e) { if (e.detail && e.detail.items) cart = e.detail; });
  function guarda(P) {
    if (P._pcObs) return;
    P._pcObs = true;
    var era = P.classList.contains('is-open');
    new MutationObserver(function () {
      var ora = P.classList.contains('is-open');
      if (ora && !era) setTimeout(function () { apre(P); }, 0);
      era = ora;
    }).observe(P, { attributes: true, attributeFilter: ['class'] });
  }
  function scan() { $$('[data-e-addp], [data-e-lv-add]').forEach(guarda); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
